import { selector } from "recoil"

import { pluginStudioAtom } from "../atoms/pluginStudioAtom"
import { TestCase, TestCaseUser } from "../types"

// Get the active test case
export const activeTestCaseSelector = selector<TestCase | null>({
  key: "pluginStudio.activeTestCase",
  get: ({ get }) => {
    const state = get(pluginStudioAtom)
    const testCases = state.testCases
    const activeTestCaseId = state.activeTestCaseId

    if (!activeTestCaseId || testCases.length === 0) {
      // If no active test case id, return the first test case if available
      return testCases.length > 0 ? testCases[0] : null
    }

    return (
      testCases.find((testCase) => testCase.id === activeTestCaseId) || null
    )
  },
})

// Get the active user from live data
export const activeLiveUserSelector = selector<TestCaseUser | null>({
  key: "pluginStudio.activeLiveUser",
  get: ({ get }) => {
    const state = get(pluginStudioAtom)
    const liveData = state.liveData

    if (!liveData.activeUserId || liveData.users.length === 0) {
      return null
    }

    return (
      liveData.users.find((user) => user.id === liveData.activeUserId) || null
    )
  },
})

// Check if live data has been modified compared to the source test case
export const liveDataModifiedSelector = selector<boolean>({
  key: "pluginStudio.liveDataModified",
  get: ({ get }) => {
    const state = get(pluginStudioAtom)
    return state.liveData.isDirty
  },
})
